import {
  SUBMIT_FETCH_BENCHMARKING_REQUEST,
  SUBMIT_FETCH_BENCHMARKING_SUCCESS,
  SUBMIT_FETCH_BENCHMARKING_FAILURE,
} from "../actions/fetchBenchmarkingActions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const fetchBenchmarkingReducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_FETCH_BENCHMARKING_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_FETCH_BENCHMARKING_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_FETCH_BENCHMARKING_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default fetchBenchmarkingReducer;
